export interface IQuery { }

export class AllPipelinesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.AllPipelinesQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string

	constructor (organizationUnitId: string)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.AllPipelinesQueryV1, TCh.Domain.Integrations'
	}

}

export class PipelineDataPreviewQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.PipelineDataPreviewQueryV1, TCh.Domain.Integrations'

	PipelineId: string

	constructor (pipelineId: string)
	{
		this.PipelineId = pipelineId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.PipelineDataPreviewQueryV1, TCh.Domain.Integrations'
	}

}

export class PipelineDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.PipelineDetailsQueryV1, TCh.Domain.Integrations'

	PipelineId: string

	constructor (pipelineId: string)
	{
		this.PipelineId = pipelineId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.PipelineDetailsQueryV1, TCh.Domain.Integrations'
	}

}

export class PipelinePropertyNamesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.PipelinePropertyNamesQueryV1, TCh.Domain.Integrations'

	PipelineId: string

	constructor (pipelineId: string)
	{
		this.PipelineId = pipelineId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.PipelinePropertyNamesQueryV1, TCh.Domain.Integrations'
	}

}

export class PipelinesDashboardQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.PipelinesDashboardQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string

	constructor (organizationUnitId: string)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.PipelinesDashboardQueryV1, TCh.Domain.Integrations'
	}

}

export class PipelineTriggerQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Pipelines.Queries.PipelineTriggerQueryV1, TCh.Domain.Integrations'

	PipelineId: string

	constructor (pipelineId: string)
	{
		this.PipelineId = pipelineId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Pipelines.Queries.PipelineTriggerQueryV1, TCh.Domain.Integrations'
	}

}

